import type { CompanyRegistryCountry } from '@insio/validation';
import type { CompanyRegistryLookupData } from '@/hooks/use-company-registry-lookup';

/** The tax IDs a register lookup writes: all of them where the register publishes them, else only those found. */
export function registryTaxIds(result: CompanyRegistryLookupData): {
  taxId?: string | null;
  vatId?: string | null;
} {
  // Where the register publishes tax IDs it is authoritative: no DIČ means the subject has none,
  // so an earlier value is cleared. SK's RPO publishes none, so there manual entries stay.
  if (result.publishesTaxIds) {
    return { taxId: result.taxId ?? null, vatId: result.vatId ?? null };
  }
  return {
    ...(result.taxId ? { taxId: result.taxId } : {}),
    ...(result.vatId ? { vatId: result.vatId } : {})
  };
}

/** The registered address as a whole address input; a part the register lacks becomes `empty`. */
export function registryAddress<E extends string | null>(
  result: CompanyRegistryLookupData,
  countryCode: CompanyRegistryCountry,
  empty: E
) {
  return {
    streetName: result.address?.streetName || empty,
    buildingNumber: result.address?.buildingNumber || empty,
    city: result.address?.city || empty,
    postalCode: result.address?.postalCode || empty,
    countryCode
  };
}
